module.exports = __webpack_public_path__ + "static/media/buscar 1.404977ed.svg";